import { useMutation } from "@tanstack/react-query";
import { useContext } from "react";
import CartContext from "../../context/cart";
import UserContext from "../../context/user";

const useCartBookingCreateMutation = (options) => {
  const { campaign } = useContext(CartContext);
  const { callApi } = useContext(UserContext);

  return useMutation(
    ({ pickUpPointId, dateFrom }) =>
      callApi(`/cart/booking/${campaign?.id}/${pickUpPointId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          from: dateFrom.second(0).millisecond(0).toISOString(),
        }),
      }),
    options
  );
};

export default useCartBookingCreateMutation;

export const useCartBookingCreateWithErrorMutation = () => {
  const { setCurrentSectionIndex, setSlotNotAvailable } = useContext(CartContext);
  return useCartBookingCreateMutation({
    onError: (error) => {
      if (error.status === 403) {
        setCurrentSectionIndex((current) => current + 1);
        setSlotNotAvailable(true);
      }
    },
  });
};
